import { z } from 'zod';

import { schemaISODateString } from '../../isISO8601';
import objectPassthrough from '../../objectPassthrough';
import { ISODateString } from '../../types';

export interface ImportInfo {
  // An id for the import process, identifying all logins from the same import
  // format: keepass-2026-01-01-fksjl
  readonly importId: string;
  readonly importTime: ISODateString;
}

export const ImportInfo = objectPassthrough({
  importId: z.string(),
  importTime: schemaISODateString,
});
